export const ExamManagementColors = {
   exam: "#5DC597",
   section: "#E3939A",
   question: "#F4B641",
}
